import * as tslib_1 from "tslib";
import createFromViewState from './createFromViewState';
import createPolicyTipsViewState from './createPolicyTipsViewState';
import createSignatureBlock from './createSignatureBlock';
import createSubjectViewState from './createSubjectViewState';
import getEncryptionInfoBarMessageId from './getEncryptionInfoBarMessageId';
import { getDefaultFromAddress } from './getFromAddresses';
import getSignature from './getSignature';
import { infoBarAddHandler, infoBarRemoveHandler } from './infoBarHandlers';
import isEncryptionFeatureEnabled from './isEncryptionFeatureEnabled';
import shouldAlwaysShowBcc from './shouldAlwaysShowBcc';
import shouldAlwaysShowFrom from './shouldAlwaysShowFrom';
import shouldAutoAddSignature from './shouldAutoAddSignature';
import createComposePlugins from '../plugins/createComposePlugins';
import createDockingViewState from '../plugins/docking/utils/createDockingViewState';
import { lazyGetAttachmentWellForCompose } from 'owa-attachment-well-data';
import { getUserMailboxInfo } from 'owa-client-ids';
import createFindPeopleFeedbackManager from 'owa-controls-findpeople-feedback-manager/lib/actions/createFindPeopleFeedbackManager';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { lazyCreateUndo } from 'owa-editor';
import createAccCheckerViewState from 'owa-editor-acc-checker-plugin/lib/utils/createAccCheckerViewState';
import createEmojiContextualSearchViewState from 'owa-editor-emojiplugin/lib/utils/createEmojiContextualSearchViewState';
import createAtMentionsViewState from 'owa-editor-mentionsplugin/lib/utils/createAtMentionsViewState';
import { createPasteOptionViewState } from 'owa-editor-paste-option-plugin';
import createRibbonViewState from 'owa-editor-ribbonplugin/lib/utils/createRibbonViewState';
import { createTableEditViewState } from 'owa-editor-table-edit-plugin';
import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import convertInlineCss from 'roosterjs-editor-dom/lib/utils/convertInlineCss';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
var nextComposeId = 0;
function getNextComposeId() {
    return (nextComposeId++).toString();
}
export default function createComposeViewState(props) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var operation, bodyType, itemId, subject, newContent, quotedBody, to, cc, bcc, attachments, referenceItemId, referenceItemDocumentId, conversationId, importance, alternateSignature, preferAsyncSend, from, pendingSocialActivityTags, IRMData, useSmartResponse, logTraceId, isPopout, smartReplyExtractionId, isInlineCompose, isCcShown, isBccShown, isRibbonShown, updatedContent, autoSignature, isFromShown, defaultFrom, defaultFromAddress, infoBarIds, findPeopleFeedbackManager, toWell, composeId, composeViewState, _a, undo;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    operation = props.operation, bodyType = props.bodyType, itemId = props.itemId, subject = props.subject, newContent = props.newContent, quotedBody = props.quotedBody, to = props.to, cc = props.cc, bcc = props.bcc, attachments = props.attachments, referenceItemId = props.referenceItemId, referenceItemDocumentId = props.referenceItemDocumentId, conversationId = props.conversationId, importance = props.importance, alternateSignature = props.alternateSignature, preferAsyncSend = props.preferAsyncSend, from = props.from, pendingSocialActivityTags = props.pendingSocialActivityTags, IRMData = props.IRMData, useSmartResponse = props.useSmartResponse, logTraceId = props.logTraceId, isPopout = props.isPopout, smartReplyExtractionId = props.smartReplyExtractionId;
                    isInlineCompose = !!conversationId;
                    isCcShown = (cc && cc.length > 0) || (isConsumer() ? shouldAlwaysShowBcc() : !isInlineCompose);
                    isBccShown = (bcc && bcc.length > 0) || shouldAlwaysShowBcc();
                    isRibbonShown = bodyType == 'HTML';
                    updatedContent = quotedBody || '';
                    autoSignature = shouldAutoAddSignature(operation)
                        ? getSignature(bodyType)
                        : alternateSignature;
                    if (autoSignature) {
                        // The signature goes above the existing content, i.e. for reply/forward, we want the signature to be added
                        // above the quoted body
                        updatedContent =
                            createSignatureBlock(bodyType, autoSignature, true /*isAutoSignature*/) +
                                convertInlineCss(updatedContent);
                    }
                    // If we have newContent, append it to the top of the updatedContent so it's above the signature.
                    updatedContent = (convertInlineCss(newContent) || '') + convertInlineCss(updatedContent);
                    isFromShown = !isInlineCompose && (shouldAlwaysShowFrom() || from != null);
                    defaultFrom = null;
                    if (!from) {
                        defaultFromAddress = getDefaultFromAddress(referenceItemId);
                        if (defaultFromAddress) {
                            defaultFrom = {
                                MailboxType: 'Mailbox',
                                RoutingType: 'SMTP',
                                EmailAddress: defaultFromAddress,
                                Name: getUserConfiguration().SessionSettings.UserDisplayName,
                            };
                        }
                    }
                    infoBarIds = isEncryptionFeatureEnabled() && IRMData
                        ? [getEncryptionInfoBarMessageId(IRMData.RmsTemplateId)]
                        : [];
                    findPeopleFeedbackManager = createFindPeopleFeedbackManager();
                    toWell = createRecipientWell(findPeopleFeedbackManager, to);
                    composeId = getNextComposeId();
                    composeViewState = {
                        // EditorViewState
                        content: updatedContent,
                        isDirty: false,
                        // Message properties
                        operation: operation,
                        itemId: itemId,
                        bodyType: bodyType,
                        subject: subject || '',
                        attachmentWell: null,
                        referenceItemId: referenceItemId,
                        referenceItemDocumentId: referenceItemDocumentId,
                        importance: importance || 'Normal',
                        fromViewState: createFromViewState(isFromShown, from ? from : defaultFrom),
                        subjectViewState: createSubjectViewState(composeId, operation, subject, newContent),
                        subjectPickerViewState: {
                            isPickerOpened: false,
                            supportsSubjectPicker: operation === 0 /* New */ && !subject && !newContent,
                            isLoadingConversation: false,
                        },
                        IRMData: IRMData,
                        policyTipsViewState: createPolicyTipsViewState(),
                        // recipient well
                        findPeopleFeedbackManager: findPeopleFeedbackManager,
                        toRecipientWell: toWell,
                        ccRecipientWell: isCcShown
                            ? createRecipientWell(findPeopleFeedbackManager, cc, toWell.contactPicker)
                            : null,
                        bccRecipientWell: isBccShown
                            ? createRecipientWell(findPeopleFeedbackManager, bcc, toWell.contactPicker)
                            : null,
                        // UI properties
                        isInlineCompose: isInlineCompose,
                        conversationId: conversationId,
                        lastSaveTimeStamp: null,
                        isRibbonShown: isRibbonShown,
                        isSending: false,
                        isSavingSpinnerShown: false,
                        infoBarIds: infoBarIds,
                        showCompactRecipientWell: isInlineCompose,
                        dropViewState: createDropViewState(),
                        isFocusWorkaroundDivShown: true,
                        showSendDiscardAsIcon: false,
                        lastFocusedControl: null,
                        isPopout: isPopout,
                        // UpConvert
                        quotedBody: null,
                        useSmartResponse: isInlineCompose || useSmartResponse,
                        // Plugins
                        emoji: createEmojiContextualSearchViewState(),
                        docking: createDockingViewState(isRibbonShown, isInlineCompose, isMailFeatureEnabled('cmp-stickyDocking'), isPopout),
                        ribbon: createRibbonViewState(),
                        atMentions: createAtMentionsViewState(pendingSocialActivityTags),
                        pasteOption: createPasteOptionViewState(),
                        tableEdit: createTableEditViewState(),
                        accChecker: createAccCheckerViewState(),
                        // Async Send
                        preferAsyncSend: preferAsyncSend,
                        asyncSendState: 0 /* None */,
                        // Internal data, for multiple compose instance
                        composeId: composeId,
                        logTraceId: logTraceId,
                        // For smart reply
                        smartReplyExtractionId: smartReplyExtractionId,
                    };
                    _a = composeViewState;
                    return [4 /*yield*/, lazyGetAttachmentWellForCompose.import()];
                case 1:
                    _a.attachmentWell = (_b.sent())({
                        attachments: attachments,
                        mailboxInfo: getUserMailboxInfo(),
                        parentItemId: itemId,
                        infoBarAddHandler: infoBarAddHandler(composeViewState),
                        infoBarRemoveHandler: infoBarRemoveHandler(composeViewState),
                    });
                    return [4 /*yield*/, lazyCreateUndo.import()];
                case 2:
                    undo = (_b.sent())(true /*preserveSnapshots*/);
                    createComposePlugins(composeViewState, undo);
                    return [2 /*return*/, composeViewState];
            }
        });
    });
}
//# sourceMappingURL=createComposeViewState.js.map